import { Component, Host, h, Prop, Watch } from '@stencil/core';

interface UiCmsRealEstateSearchProps {
  headline?: string;
  text?: string;
  image?: string;
  imageAltText?: string;
  imageCopyright?: string;
  imageMouseoverText?: string;
  usageTypeId?: string;
  resultsPerPage?: number;
  apiUrl?: string;
  apiKey?: string;
  apiVersion?: string;
  noResultMessageTitle?: string;
  noResultMessageHtml?: string;
  realEstatePagePath: string;
}

@Component({
  tag: 'ui-cms-realestate-search',
  styleUrl: 'ui-cms-realestate-search.css',
  shadow: false,
})
export class UiCmsRealEstateSearch {
  @Prop({ mutable: true }) body: UiCmsRealEstateSearchProps = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop({ mutable: true }) i18n = {
    filters: 'Filter',
    closeFilters: 'Filter schließen',
    realEstateObjects: 'Objekte',
    from: 'von',
    to: 'bis',
    searchProperties: 'Suchen',
    resetFilters: 'Alle Filter Zurücksetzen',
    acquisitionYear: 'Erwerbsjahr',
    map: 'Karte',
    list: 'Liste',
    usableArea: 'Nutzfläche',
    usageType: 'Hauptnutzungsart',
    fonds: 'Fonds',
    readMore: 'Mehr erfahren',
    realEstateObjectHomepage: 'Objekt Homepage',
    yearError: 'Das Jahr muss mit 4 Ziffern angegeben werden.',
  };

  @Prop({ attribute: 'i18n' }) utilityI18n: string;

  @Watch('utilityI18n')
  utilityI18nChangeHandler(newValue: string) {
    if (newValue) this.i18n = { ...JSON.parse(newValue) };
  }

  @Watch('utilityBody')
  utilityBodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.utilityI18nChangeHandler(this.utilityI18n);
    this.utilityBodyChangeHandler(this.utilityBody);
  }

  render() {
    return (
      <Host>
        {this.body && (
          <ui-realestate-search
            headline={this.body.headline}
            text={this.body.text}
            image={this.body.image}
            imageAltText={this.body.imageAltText}
            imageCopyright={this.body.imageCopyright}
            imageMouseoverText={this.body.imageMouseoverText}
            usageTypeId={this.body.usageTypeId}
            resultsPerPage={this.body.resultsPerPage}
            apiUrl={this.body.apiUrl}
            apiKey={this.body.apiKey}
            apiVersion={this.body.apiVersion}
            replace="%RENDITION%"
            i18n={this.i18n}
            noResultMessageTitle={this.body.noResultMessageTitle}
            noResultMessageHtml={this.body.noResultMessageHtml}
            realEstatePagePath={this.body.realEstatePagePath}
          ></ui-realestate-search>
        )}
      </Host>
    );
  }
}
